import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'ducks';

export interface RangeState {
  selectedRange: string;
  hiddenProductGroups: string[];
}

const initialState: RangeState = {
  selectedRange: '',
  hiddenProductGroups: []
};

const rangeSlice = createSlice({
  name: 'range',
  initialState,
  reducers: {
    setSelectedRange(state, action: PayloadAction<string>) {
      state.selectedRange = action.payload;
    },
    setHiddenProductGroups(state, action: PayloadAction<string[]>) {
      state.hiddenProductGroups = action.payload;
    }
  }
});

export const getSelectedRange = (state: RootState) => state.range.selectedRange;
export const getHiddenProductGroups = (state: RootState) => state.range.hiddenProductGroups;

export const { setSelectedRange, setHiddenProductGroups } = rangeSlice.actions;
export default rangeSlice.reducer;
